'use strict';

/* global angular */
const UploaderRoutes = require('./UploaderRoutes');
const UploaderStore = require('./UploaderStore');
const UploaderPageController = require('./UploaderPageController');
const SpinnerDirective = require('../manager/directives/SpinnerDirective');

angular
.module('uploader', [
  'uploader.uploaderStore'
])
// Routing
.directive('uploaderSpinner', SpinnerDirective)

.config(UploaderRoutes)
.controller('UploaderPageController', UploaderPageController);



/** uploader.UploaderStore Module initialization */
angular.module('uploader.uploaderStore', [])
  .service('UploaderStore', UploaderStore)
  .run(['UploaderStore', function (UploaderStore) {
    UploaderStore.init();
  }]);




// WEBPACK FOOTER //
// ./src/app/uploader/index.js